<div class="flex justify-content-end align-items-right py-3">
  <span class="p-input-icon-right">
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
    <i tabindex="0" role="button" class="pi pi-search text-color-secondary" (click)="handleFullSearch()"></i>
    <p-autoComplete id="filterByPhysiciansName"
      [suggestions]="algoliaSuggestionsList"
      (completeMethod)="onSearch($event)"
      (onClear)="onClear()"
      (onSelect)="onOptionSelection($event)"
      [(ngModel)]="selectedSearchItemName"
      (keydown.enter)="handleFullSearch()"
      dropdown="false"
      [showClear]="true"
      placeholder="{{ 'Search.SearchHere' | translate }}"
      styleClass="w-full"
      [style]="{width: '100%'}"
      [inputStyle]="{width: '100%'}"
      [minLength]="3"
      [maxlength]="100" />
  </span>
</div>
